import '~/assets/scss/opif.scss'

import Filters from '~/js/modules/filters';
import getSwiperSlider from '~/js/modules/slider';
import StockChart from '~/js/modules/stock-chart';
import Accordion from '~/js/modules/accordion';
import '~/js/modules/online-request';
import '~/js/modules/promo-banner';
import '~/js/modules/zlata';
import Tabs from '~/js/modules/tabs';

window.addEventListener(`DOMContentLoaded`, () => {
  const productsSliders = document.querySelectorAll(`.products__slider-mobile`);
  const productsChartBlocks = document.querySelectorAll(`.products__chart-block`);
  const filterButtons = document.querySelectorAll(`.filters__link`);
  const accordions = document.querySelectorAll(`.accordion`);
  // const forms = document.querySelectorAll(`.form__form`);
  const cart = document.querySelector('.js-cart');
  const buyButton = document.querySelectorAll(`.js-buy`);
  const buyPif = document.querySelector(`.js-buy-pif`);
  const cartButton = document.querySelector(`.js-cart-button`);
  const pifCounter = cartButton.querySelector(`.js-pif-counter`);
  const closeCart = cart.querySelector('.js-close-btn')
  const cartBody = cart.querySelector('.js-cart-body')
  const productContainers = document.querySelectorAll(`.products__cards`);
  const filtersControls = document.querySelectorAll(`.js-filters-controls`);
  let productsSwipers = [{}, {}];

  if (accordions.length) {
    accordions.forEach((accordion) => {
      if (!accordion.classList.contains('main-nav__list') && !accordion.classList.contains('service-request--accordion')) {
        new Accordion(accordion)
      }
    });
  }

  buyButton.forEach((bb) => {
    if (bb) {
      bb.addEventListener('click', (e) => {
        add_pif(bb, e)
      })
    }
  });

  let sort_pifs = function (pifType = "growth") {
    if(pifType === "growth") {
      productContainers.forEach((pc) => {
        let productCard = Array.from(pc.querySelectorAll('.products__slide'));

        productCard.sort((a, b) => {
          return b.dataset.growth - a.dataset.growth;
        });

        productCard.forEach(productCard => pc.appendChild(productCard));
      });
    }
    else if(pifType === "popular") {
      productContainers.forEach((pc) => {
        let productCard = Array.from(pc.querySelectorAll('.products__slide'));

        productCard.sort((a, b) => {
          return b.dataset.popular - a.dataset.popular;
        });

        productCard.forEach(productCard => pc.appendChild(productCard));
      });
    }
    else {
      productContainers.forEach((pc) => {
        let productCard = Array.from(pc.querySelectorAll('.products__slide'));
        productCard.sort((a, b) => {
          const dateA = new Date(a.dataset.new);
          const dateB = new Date(b.dataset.new);

          return dateB - dateA;
        });

        productCard.forEach(productCard => pc.appendChild(productCard));
      });
    }
  }

  let filter_pifs = function (filterType, filterValue = 0) {
    if(filterType == "period") {
      productContainers.forEach((pc) => {
        let productCard = pc.querySelectorAll('.products__slide');

        productCard.forEach((card) => {
          if(Number(filterValue) == 0) {
            if(card.dataset.showAktiv == 1 && card.dataset.showRisk == 1) {
              card.style.display = 'flex'
            }
            card.dataset.showPeriod = 1
          }
          else if(Number(filterValue) == 1) {
            if(Number(card.dataset.period) == 1) {
              if(card.dataset.showAktiv == 1 && card.dataset.showRisk == 1) {
                card.style.display = 'flex'
              }
              card.dataset.showPeriod = 1
            }
            else {
              card.style.display = 'none'
              card.dataset.showPeriod = 0
            }
          }
          else if(Number(filterValue) == 2) {
            if(Number(card.dataset.period) == 2 || Number(card.dataset.period) == 3) {
              if(card.dataset.showAktiv == 1 && card.dataset.showRisk == 1) {
                card.style.display = 'flex'
              }
              card.dataset.showPeriod = 1
            }
            else {
              card.style.display = 'none'
              card.dataset.showPeriod = 0
            }
          }
          else {
            if(Number(card.dataset.period) > 3) {
              if(card.dataset.showAktiv == 1 && card.dataset.showRisk == 1) {
                card.style.display = 'flex'
              }
              card.dataset.showPeriod = 1
            }
            else {
              card.style.display = 'none'
              card.dataset.showPeriod = 0
            }
          }
        })
      });
    }
    else if(filterType == "risk") {
      productContainers.forEach((pc) => {
        let productCard = pc.querySelectorAll('.products__slide');

        productCard.forEach((card) => {
          if(Number(filterValue) == 0) {
            if(card.dataset.showAktiv == 1 && card.dataset.showPeriod == 1) {
              card.style.display = 'flex'
            }
            card.dataset.showRisk = 1
          }
          else if(Number(filterValue) == 1) {
            if(Number(card.dataset.risk) == 1 || Number(card.dataset.risk) == 2) {
              if(card.dataset.showAktiv == 1 && card.dataset.showPeriod == 1) {
                card.style.display = 'flex'
              }
              card.dataset.showRisk = 1
            }
            else {
              card.style.display = 'none'
              card.dataset.showRisk = 0
            }
          }
          else if(Number(filterValue) == 2) {
            if(Number(card.dataset.risk) == 3) {
              if(card.dataset.showAktiv == 1 && card.dataset.showPeriod == 1) {
                card.style.display = 'flex'
              }
              card.dataset.showRisk = 1
            }
            else {
              card.style.display = 'none'
              card.dataset.showRisk = 0
            }
          }
          else {
            if(Number(card.dataset.risk) > 3) {
              if(card.dataset.showAktiv == 1 && card.dataset.showPeriod == 1) {
                card.style.display = 'flex'
              }
              card.dataset.showRisk = 1
            }
            else {
              card.style.display = 'none'
              card.dataset.showRisk = 0
            }
          }
        })
      });
    }
    else {
      productContainers.forEach((pc) => {
        let productCard = pc.querySelectorAll('.products__slide');

        productCard.forEach((card) => {
          if(Number(filterValue) == 0) {
            if(card.dataset.showPeriod == 1 && card.dataset.showRisk == 1) {
              card.style.display = 'flex'
            }
            card.dataset.showAktiv = 1
          }
          else {
            if(card.dataset.aktiv == filterValue) {
              if(card.dataset.showPeriod == 1 && card.dataset.showRisk == 1) {
                card.style.display = 'flex'
              }
              card.dataset.showAktiv = 1
            }
            else {
              card.style.display = 'none'
              card.dataset.showAktiv = 0
            }
          }
        })
      });
    }
  }

  const filterDrop = document.querySelectorAll(`.js-filter-drop`);
  const filterDropdown = document.querySelectorAll(`.js-filter-dropdown`);
  if (filterDrop.length) {
    filterDrop.forEach((fd) => {
      fd.addEventListener('click', () => {
        fd.classList.toggle('active')
        filterDropdown.forEach((fild) => {
          if(fd.dataset.id == fild.dataset.id) {
            if(fd.classList.contains('active')) {
              fild.style.display = 'flex';
            }
            else {
              fild.style.display = 'none';
            }
          }
          else {
            fild.style.display = 'none';
          }
        })
      })
    })
  }
  const pifFilterButtons = document.querySelectorAll('.js-filter-button')
  if (pifFilterButtons.length) {
    pifFilterButtons.forEach((fb) => {
      fb.addEventListener('click', () => {
        filter_pifs(fb.dataset.type, fb.dataset.filt)
        pifFilterButtons.forEach((filb) => {
          if(filb == fb) {
            filb.classList.add('active')
          }
          else {
            filb.classList.remove('active')
          }
        })
        filterDropdown.forEach((fild) => {
          fild.style.display = 'none';
        })

        filterDrop.forEach((fd) => {
          if(fd.classList.contains('active')) {
            fd.classList.remove('active')
            if(fb.dataset.type == fd.dataset.id) {
              fd.innerHTML = fb.innerHTML + '<svg xmlns="http://www.w3.org/2000/svg"><use href="assets/dist/img/sprite.svg#i-arrow-accordion1"></use></svg>'
            }
          }
        })
      })
    })
  }

  const sortingDrop = document.querySelectorAll(`.js-sort-drop`);
  const sortingDropdown = document.querySelector(`.js-sort-dropdown`);
  if (sortingDrop.length) {
    sortingDrop.forEach((sd) => {
      sd.addEventListener('click', () => {
        sd.classList.toggle('active')
        if(sd.classList.contains('active')) {
          sortingDropdown.style.display = 'flex';
        }
        else {
          sortingDropdown.style.display = 'none';
        }
      })
    })
  }
  productContainers.forEach((pc) => {
    let productCard = Array.from(pc.querySelectorAll('.products__slide'));
    productCard.forEach((card) => {
      card.dataset.popular = Number(card.dataset.popular.replace(/\s+/g, '').replace(',', '.'));
      card.dataset.growth = Number(card.dataset.growth.replace(',', '.'));
    });
    sort_pifs()
  })
  const sortingButtons = document.querySelectorAll('.js-sorting-button')
  if (sortingButtons.length) {
    sortingButtons.forEach((sb) => {
      sb.addEventListener('click', () => {
        sort_pifs(sb.dataset.sort)
        sortingButtons.forEach((sorb) => {
          if(sorb == sb) {
            sorb.classList.add('active')
          }
          else {
            sorb.classList.remove('active')
          }
        })
        sortingDropdown.style.display = 'none';
        sortingDrop.forEach((sd) => {
          if (window.innerWidth >= 960) {
            if(sd.classList.contains('active')) {
              sd.classList.remove('active')
              sd.innerHTML = sb.innerHTML + '<svg xmlns="http://www.w3.org/2000/svg"><use href="assets/dist/img/sprite.svg#i-arrow-accordion1"></use></svg>'
            }
          } else {
            sd.classList.remove('active')
          }
        })
      })
    })
  }

  const productsSwiperParams = {
    slidesPerView: `auto`,
    loop: false,
    autoplay: false,
    navigation: false,
    pagination: false,
  };

  if (window.innerWidth < 1024) {
    productsSliders.forEach((it, i) => {
      if (it) {
        productsSwipers[i] = getSwiperSlider(it, productsSwiperParams);
        it.swiper.update();
      }
    });

    if (filterButtons.length) {
      filterButtons.forEach((fb) => {
        fb.addEventListener('click', () => {
          productsSliders.forEach((it, i) => {
            if (it.swiper && it.swiper.initialized) {
              it.swiper.destroy();
            }
            productsSwipers[i] = setTimeout(getSwiperSlider, 100, it, productsSwiperParams);
          });
        })
      });
    }
  }

  if (filtersControls.length) {
    filtersControls.forEach((fc, i) => {
      new Filters(fc);

      productsSliders.forEach((it, i) => {
        if (it.swiper && it.swiper.initialized) {
          it.swiper.destroy();
        }
        productsSwipers[i] = setTimeout(getSwiperSlider, 100, it, productsSwiperParams);
      })
    });
  }

  const productsStockChartNames = [`MSFT`];
  const productsStockChartOptions = {
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    navigator: {
      enabled: false,
    },
    plotOptions: {
      line: {
        enableMouseTracking: false
      },
    },
    rangeSelector: {
      enabled: false,
    },
    scrollbar: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    xAxis: {
      crosshair: false,
      labels: {
        enabled: false,
      },
      lineWidth: 0,
      range: 365 * 24 * 60 * 60 * 1000, // 1 year
      tickLength: 0,
    },
    yAxis: {
      gridLineWidth: 0,
      labels: {
        enabled: false,
      },
    },
    series: [],
    seriesCounter: 0,
  };

  productsChartBlocks.forEach((chart, i) => {
    productsStockChartOptions.chart = {
      spacing: 0,
      width: chart.offsetWidth,
      height: chart.offsetHeight,
    };
    productsStockChartOptions.names = i >= productsStockChartNames.length - 1
      ? [productsStockChartNames[0]]
      : [productsStockChartNames[i]];

    return new StockChart({
      chart,
      options: productsStockChartOptions,
    });
  });

  window.addEventListener(`resize`, () => {
    if (window.innerWidth >= 1024) {
      productsSwipers.forEach((it) => {
        if (it.initialized) {
          it.destroy();
        }
      });
    } else {
      productsSwipers.forEach((it, i) => {
        if (!it.initialized) {
          productsSwipers[i] = getSwiperSlider(productsSliders[i], productsSwiperParams);
        }
      });
    }
  })

  const mainTabsControls = document.querySelectorAll(".js-tabs-controls-main")
  const mainTabsContainer = document.querySelectorAll(".js-tabs-container-main")
  if (mainTabsControls.length && mainTabsContainer.length) {
    mainTabsControls.forEach((control, i) => new Tabs(control, mainTabsContainer[i], '-main'))
  }

  let update_count = function (up = false) {
    let count = parseInt(pifCounter.textContent)
    let prevCount = count;

    if(up) {
      count++;
    }
    else {
      count--;
    }
    pifCounter.textContent = count.toString();
    cartButton.style.display = count ? 'flex' : 'none';
    if(prevCount == 0 && count == 1) {
      cart.classList.toggle('active');
    }
    if(count == 0) {
      cart.classList.remove('active')
    }
  }

  let delete_pif = function (opn) {
    let ids = buyPif.dataset.openLink.split('=')[1].split(',')
    if (ids.indexOf(opn) !== -1) {
      ids.splice(ids.indexOf(opn), 1);
    }
    buyPif.dataset.openLink = buyPif.dataset.openLink.split('=')[0] + '=' + ids.join(',')
    buyPif.dataset.openKidsLink = buyPif.dataset.openKidsLink.split('=')[0] + '=' + ids.join(',')
  }

  let add_pif = function (bb, e) {
    e.stopPropagation()
    e.preventDefault()
    bb.classList.toggle('active')

    if(bb.classList.contains('active')) {
      if(parseInt(pifCounter.textContent) != 0) {
        buyPif.dataset.openLink = buyPif.dataset.openLink + ',' + bb.dataset.openId
        buyPif.dataset.openKidsLink = buyPif.dataset.openKidsLink + ',' + bb.dataset.openId
      }
      else {
        buyPif.dataset.openLink = buyPif.dataset.openLink + bb.dataset.openId
        buyPif.dataset.openKidsLink = buyPif.dataset.openKidsLink + bb.dataset.openId
      }
      const newPif = document.createElement('div')
      const deletePif = document.createElement('button')
      const bottomContainer = document.createElement('div')
      const description = '<p class="description">' + bb.dataset.description + '</p>'
      let risk = ''
      update_count(true)

      deletePif.className = 'delete-button'
      deletePif.innerHTML = '<div class="circle">'
        + '<svg class="trs" xmlns="http://www.w3.org/2000/svg">'
        + '<use href="/assets/dist/img/sprite.svg#i-trash"></use>'
        + '</svg>'
        + '</div>';

      for(let i=1;i<=5;i++) {
        if(bb.dataset.risk >= i) {
          risk = risk + '<div class="risk active"></div>'
        }
        else {
          risk = risk + '<div class="risk"></div>'
        }
      }

      const percent = bb.parentNode.querySelector('.percent')

      bottomContainer.className = 'bottom-container'
      bottomContainer.appendChild(deletePif)

      newPif.className = 'pif-card'
      newPif.dataset.pif = bb.dataset.id
      newPif.innerHTML = '<div class="info-container">'
        + '<div class="head">'
        + '<span class="name">' + bb.dataset.name + '</span>'
        + '<div class="risk-container">'
        + risk
        + '</div>'
        + '</div>'
        + description
        + '<div class="growth-container">'
        + (percent ? percent.outerHTML : '')
        + (percent ? '<span class="date">с ' + bb.dataset.start + ' г.</span>' : '<span class="date">Фонд в стадии</br>формирования</span>')
        + '</div>'
        + '</div>'
        + description
      newPif.appendChild(bottomContainer)

      deletePif.addEventListener('click', (e) => {
        document.querySelector('[data-id="' + newPif.dataset.pif + '"]').classList.toggle('active')
        newPif.remove()
        delete_pif(bb.dataset.openId)
        update_count()
      })

      cartBody.appendChild(newPif)
    }
    else {
      delete_pif(bb.dataset.openId)
      document.querySelector('[data-pif="' + bb.dataset.id + '"]').remove()
      update_count()
    }
  }
  closeCart.addEventListener('click', (e) => {
    cart.classList.toggle('active')
  })

  cartButton.addEventListener('click', (e) => {
    cart.classList.toggle('active')
  })

  // Check for the presence of the `buyfund` parameter in the URL
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.get('buyfund')) {
    const buyfundIds = urlParams.get('buyfund').split(',')
    buyfundIds.forEach((id) => {
      const targetButton = document.querySelector(`.js-buy[data-id="${id}"]`)
      if (targetButton) {
        add_pif(targetButton, new Event('click'));
      }
    })
  }

  document.querySelectorAll('.js-scroll-button').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('data-href')).scrollIntoView({ block: "start", behavior: "smooth" });
    });
  });
});
